(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/router/assets/javascripts/mcl-route.js') >= 0) return;  svs.modules.push('/components/app/router/assets/javascripts/mcl-route.js');
"use strict";

const _excluded = ["componentName", "componentProps", "getComponent", "onError", "onLoading"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


const loadModuleComponent = svs.core.module.loadModuleComponent;
const useEffect = React.useEffect;
const useState = React.useState;
const Route = ReactRouterDOM.Route;
const logger = new svs.core.log.Logger('app:route:mcl-route');
const useMcl = _ref => {
  let componentName = _ref.componentName,
    getComponent = _ref.getComponent,
    componentProps = _ref.componentProps,
    onError = _ref.onError,
    onLoading = _ref.onLoading;
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  const _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    Component = _useState4[0],
    setComponent = _useState4[1];
  const _useState5 = useState({
      componentProps: null,
      onError: null,
      onLoading: null
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    componentBundle = _useState6[0],
    setComponentBundle = _useState6[1];
  const safeGetComponent = () => {
    try {
      return getComponent();
    } catch (e) {
      return undefined;
    }
  };
  useEffect(() => {
    setComponent(safeGetComponent);
    setComponentBundle({
      componentProps,
      onError,
      onLoading
    });
  }, [getComponent]); 

  useEffect(() => {
    let wasCancelled = false;
    if (!Component) {
      loadModuleComponent(componentName, err => {
        if (!wasCancelled) {
          if (err) {
            logger.error('Error loading module component', err);
            setError(err);
          } else {
            setComponent(safeGetComponent);
          }
        }
      });
    }
    return () => {
      wasCancelled = true;
    };
  }, [Component]);
  return [componentBundle.onError, componentBundle.onLoading, componentBundle.componentProps, error, Component];
};
const LoadMCl = props => {
  const _useMcl = useMcl(props),
    _useMcl2 = _slicedToArray(_useMcl, 5),
    onError = _useMcl2[0],
    onLoading = _useMcl2[1],
    componentProps = _useMcl2[2],
    error = _useMcl2[3],
    Component = _useMcl2[4];
  if (error && onError) {
    props.onError(error);
    return null;
  }
  if (!Component && onLoading) {
    props.onLoading();
    return null;
  }
  return Component ? React.createElement(Component, componentProps) : null;
};
const MclRoute = props => {
  const componentName = props.componentName,
    componentProps = props.componentProps,
    getComponent = props.getComponent,
    onError = props.onError,
    onLoading = props.onLoading,
    routeProps = _objectWithoutProperties(props, _excluded);
  return React.createElement(Route, _extends({}, routeProps, {
    render: () => React.createElement(LoadMCl, {
      componentName: componentName,
      componentProps: componentProps,
      getComponent: getComponent,
      onError: onError,
      onLoading: onLoading
    })
  }));
};
svs.app.ReactRouter.useMcl = useMcl;
svs.app.ReactRouter.MclRoute = MclRoute;

 })(window);